var React = require('react');

function Backarrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M464.3 207.4l.8.2H136l103.5-103.7c5-5.1 7.8-12 7.8-19.2 0-7.2-2.7-14-7.8-19l-16.1-16.2c-5-5-11.8-7.8-19-7.8-7.2 0-14 2.8-19 7.8L7.8 227C2.8 232 0 238.8 0 246c0 7.3 2.8 14 7.8 19.2l177.5 177.4c5 5 11.8 7.8 19 7.8 7.2 0 14-2.8 19-7.8l16-16.1a26.6 26.6 0 000-37.7L134.8 284.4h330a27.9 27.9 0 0027.3-27.6V234a27.3 27.3 0 00-27.7-26.6z","key":1})]);
}

Backarrow.defaultProps = {"viewBox":"0 0 492 492"};

module.exports = Backarrow;

Backarrow.default = Backarrow;
